import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';


const styles = {
    error: {
        backgroundColor: red[100],
        padding: '10px',
        marginTop: '5px',
        borderRadius: '5px'
    }
};

class Error extends Component {
    render() {
        const { message, classes } = this.props;
        return (
            <div className={classes.error}>
                {message}
            </div>
        );
    }
}

export default withStyles(styles)(Error);